import React from "react";
import ReactDOM from "react-dom";
// core styles
import "./scss/volt.scss";
// vendor styles
import "react-datetime/css/react-datetime.css";
import App from "./App";
import { Provider } from "react-redux";
import { store, persistor } from "./Store";
import { PersistGate } from "redux-persist/integration/react";



console.log("store", store, "persist", persistor);
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
   
    </PersistGate>
  </Provider>,
 
  document.getElementById("root")
);
